<div class="node-palette" id="node-inspector" cdkDropList (cdkDropListDropped)="drop($event)">
   <section class="palette-section" *ngFor="let section of paletteSections; trackBy: trackBySection">
      <header
         class="palette-section__header"
         role="button"
         tabindex="0"
         (click)="toggleSection(section.id)"
         (keydown.enter)="toggleSection(section.id)"
         (keydown.space)="toggleSection(section.id); $event.preventDefault()"
      >
         <div class="palette-section__title">
            <i [class]="section.icon"></i>
            <span>{{ section.titleKey | translate }}</span>
         </div>
         <div class="palette-section__meta">
            <span class="palette-section__count">{{ section.nodes.length }}</span>
            <i class="pi palette-section__toggle" [ngClass]="isSectionCollapsed(section.id) ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
         </div>
      </header>

      <div class="palette-section__body" *ngIf="!isSectionCollapsed(section.id)">
         <div
            class="palette-node"
            *ngFor="let node of section.nodes; trackBy: trackByNode"
            cdkDrag
            [id]="node.id"
            [style.--node-color]="getNodeColor(node.id)"
            [style.--node-text-color]="getNodeTextColor(node.id)"
            [pTooltip]="
               isChannelDisabled(node.id)
                  ? ('DATA.MODULES.CAMPAINGS.WORKFLOWS.CHANNEL_NOT_CONFIGURED' | translate)
                  : null
            "
            tooltipPosition="top"
         >
            <ng-container *ngIf="getNodeShape(node.id) as nodeShape">
               <div *ngIf="nodeShape === 'diamond'; else nonDiamondShape" class="palette-node__shape palette-node__shape--diamond-svg">
                  <svg class="palette-node__diamond-svg" viewBox="0 0 120 60" preserveAspectRatio="none" aria-hidden="true">
                     <polygon points="60,1.5 118.5,30 60,58.5 1.5,30"></polygon>
                  </svg>
                  <span *ngIf="isAiNode(node.id)" class="palette-node__tag">IA</span>
                  <i *ngIf="isChannelDisabled(node.id)" class="pi pi-exclamation-triangle palette-node__warning"></i>
                  <span class="palette-node__label">{{ node.name }}</span>
               </div>

               <ng-template #nonDiamondShape>
                  <div
                     *ngIf="isFlexPolygonNode(node.id); else regularShape"
                     class="palette-node__shape palette-node__shape--poly-svg"
                     [ngClass]="{
                        'palette-node__shape--poly-partial': node.id === 'offerPartialPayment',
                        'palette-node__shape--poly-agreement': node.id === 'offerPaymentAgreement'
                     }"
                  >
                     <svg
                        class="palette-node__poly-svg"
                        [attr.viewBox]="getFlexNodeViewBox(node.id)"
                        preserveAspectRatio="xMidYMid meet"
                        aria-hidden="true"
                     >
                        <polygon [attr.points]="getFlexNodePolygonPoints(node.id)"></polygon>
                     </svg>
                     <span *ngIf="isAiNode(node.id)" class="palette-node__tag">IA</span>
                     <i *ngIf="isChannelDisabled(node.id)" class="pi pi-exclamation-triangle palette-node__warning"></i>
                     <span class="palette-node__label">{{ node.name }}</span>
                  </div>
               </ng-template>

               <ng-template #regularShape>
                  <div class="palette-node__shape" [ngClass]="'palette-node__shape--' + nodeShape">
                     <span *ngIf="isAiNode(node.id)" class="palette-node__tag">IA</span>
                     <i *ngIf="isChannelDisabled(node.id)" class="pi pi-exclamation-triangle palette-node__warning"></i>
                     <span class="palette-node__label">{{ node.name }}</span>
                  </div>
               </ng-template>
            </ng-container>
         </div>
      </div>
   </section>
</div>

<p-dialog header="" [modal]="true" [(visible)]="showWarningModal" [style]="{ width: 'min(28rem, 92vw)' }">
   <div class="flex flex-column gap-3 items-start align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle text-yellow-600 mt-1" style="font-size: 2rem"></i>
      <div>
         <div class="font-bold text-lg mb-2 font-800">Alerta!</div>

         <p class="m-0 text-sm text-gray-500" *ngIf="warningType === 'channel'">
            {{ 'DATA.MODULES.CAMPAINGS.WORKFLOWS.ALERT_MISSING_CONFIG' | translate: { canal: currentChannel } }}
         </p>

         <p class="m-0 text-sm text-gray-500" *ngIf="warningType === 'waitNode'">
            Sólo puedes añadir un nodo de espera por flujo.
         </p>
      </div>

      <div class="flex justify-content-end gap-2">
         <p-button label="Entendido" severity="secondary" (onClick)="showWarningModal = false; warningType = null" />
      </div>
   </div>
</p-dialog>
